var React = require('react');
import { browserHistory } from 'react-router';
import AttemptRes from '../../resources/attempt';
import ConceptRes from '../../resources/concept';
import Auth from '../../resources/auth';
import Helpers from '../../utils/helpers';
import Solution from '../QuestionContent/Solution';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import '../../css/components/Marking/marking.css';
import notification from '../Modal/notification';
import createNotificationDialog from '../Modal/createNotificationDialog';
var moment = require('moment');
var $ = require('jquery');

import PartDescription from '../QuestionContent/LongQuestionFraction/PartDescription';
import PartAnswer from '../QuestionContent/LongQuestionFraction/PartAnswer';
import PartResult from '../QuestionContent/LongQuestionFraction/PartResult';
import MarkingProgress from './MarkingProgress';

var MarkingAttempt = React.createClass({
  retrieveAttempt: function(callback) {
    var _this = this;
    this.setState({isLoading: true}, function() {
      AttemptRes.retrieveSingleAttempt({attemptId: this.props.params.attemptId}, function(err, res) {
        _this.setState({
          attempt: (!err && res) ? res : {}
        }, function() {
          return callback(err, res);
        })
      })
    })
  },

  validateAttemptPermission: function(callback) {
    callback = callback || function(){};
    var currentUser = Auth.getCurrentUser();
    var attempt = this.state.attempt;
    if (attempt.metadata && attempt.metadata.marker && attempt.metadata.marker !== currentUser._id) {
      this.notificationDialog = createNotificationDialog({
        title: 'Error',
        content: 'This Submission has been marked by another teacher.'
      }, function() {
        if (attempt.type === 'PRACTICE') {
          browserHistory.push('/submissions/practice');
        } else {
          browserHistory.push('/submissions/exam');
        }
      })
      this.setState({openNotificationDialog: true});
    } else {
      this.updateAttemptPermission(callback);
      return callback();
    }
  },

  updateAttemptPermission: function(callback) {
    var attempt = this.state.attempt;
    var _this = this;
    if (attempt.status === 'marking' && attempt.metadata && attempt.metadata.marker) return callback();
    attempt.status = 'marking';
    if (!attempt.metadata) attempt.metadata = {};
    var user = Auth.getCurrentUser();
    attempt.metadata.marker = user._id;
    attempt.metadata.markerName = user.firstName + ' ' + user.lastName;
    AttemptRes.updateAttempt(attempt, function(err, res) {
      _this.setState({
        attempt: attempt
      }, function() {
        return callback();
      })
    })
  },

  prebuildAttemptData: function() {
    var attempt = this.state.attempt;
    var answers = [];
    if (attempt && attempt.answers && attempt.answers.length > 0) {
      for (var i = 0; i < attempt.answers.length; i++) {
        var answer = attempt.answers[i];

        var finishCount = 0;
        for (var j = 0; j < answer.textInputs.length; j++) {
          var answerInput = answer.textInputs[j];
          var textInput = answer.kquestionInfo.textInputAnswers[j];
          if (answerInput.answerValue || answerInput.answerValue === 0) {
            finishCount++;
          } else {
            if (textInput.text) { // if textInput.text is existed, this part is auto
              finishCount++;
              if (answerInput.isRight) {
                answerInput.answerValue = textInput.answerValue;
              } else {
                answerInput.answerValue = 0;
              }
            }
          }
          if (!answerInput.answerValue && answerInput.answerValue !== 0) textInput.isEditting = true;
        }

        if (answer.numPoints > 0) {
          for (var k in answer.kquestionInfo.textInputAnswers) {
            answer.kquestionInfo.textInputAnswers[k].partScore = answer.numPoints * answer.kquestionInfo.textInputAnswers[k].answerValue / answer.kquestionInfo.score; 
          }
        }

         // in case this attempt is a PRACTICE attempt, add all answers 
        // in case this attempt is a MOCK_EXAM attempt, only add answers of PART_2 which are long structure 
        if (attempt.type !== 'MOCK_EXAM' || (attempt.type === 'MOCK_EXAM' && answer.type && answer.type === 'PART_2')) {
          answers.push(answer);
        } 

        if (finishCount === answer.textInputs.length) answer.finishMarking = true;
      }
    }

    this.setState({
      attempt: attempt,
      preBuildAnswers: answers
    })
  },
  retrieveConceptsMap: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      _this.setState({
        conceptsMap: (!err && conceptsMap) ? conceptsMap : {},
        isLoading: false
      }, function() {
        return callback(err, conceptsMap);
      })
    })
  },
  submitTextInputMessage: function(textInputId) {
    var refId = "comment-answer-" + textInputId;
    var message = this.refs[refId].value;
    if(message)  {
      var indexOfAnswerInAttempt = this.state.attempt.answers.indexOf(this.state.preBuildAnswers[this.state.currentAnswerIndex])
      var answer = this.state.attempt.answers[indexOfAnswerInAttempt];
      var _this = this;
      var options = {
        text: message,
        answer: answer._id,
        metadata: {
          textInputId: textInputId
        }
      }
      AttemptRes.submitAnswerMessage(options, function(err, res) {
        _this.refs[refId].value = "";
        if (!err && res) {
          answer.messages.push(res);
        }
        _this.setState({
          attempt: _this.state.attempt
        })
      })  
    }
    
  },
  onTextInputMarkChange: function(textInput, e) {
    var mark = parseFloat(e.target.value || 0);
    var attempt = this.state.attempt;
    var onChangeAnswer = this.state.preBuildAnswers[this.state.currentAnswerIndex];
    var indexOfOnChangeAnswerInAttempt = attempt.answers.indexOf(onChangeAnswer);
    var inputIndex = attempt.answers[indexOfOnChangeAnswerInAttempt].kquestionInfo.textInputAnswers.indexOf(textInput);
    attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs[inputIndex].answerValue = mark;
    attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs[inputIndex].status = 'scored';
    this.setState({
      attempt: attempt
    })
  },
  triggerEditTextInput: function(textInput) {
    textInput.isEditting = !textInput.isEditting;
    var attempt = this.state.attempt;
    var onChangeAnswer = this.state.preBuildAnswers[this.state.currentAnswerIndex];
    var indexOfOnChangeAnswerInAttempt = attempt.answers.indexOf(onChangeAnswer);
    var inputIndex = attempt.answers[indexOfOnChangeAnswerInAttempt].kquestionInfo.textInputAnswers.indexOf(textInput);
    // Exit edit mode ----- RUN VALIDATION HERE
    if (!textInput.isEditting) {
      var mark = this.refs["text-input-" + textInput._id].value;
      var checkingScore = textInput.partScore ? textInput.partScore : textInput.answerValue;
      if (mark > checkingScore || mark < 0) {
        textInput.markError = true;
      }
      else {
        textInput.markError = false;
        attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs[inputIndex].answerValue = mark;
        var count = 0;
        for (var i = 0; i < attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs.length; i++) {
          if (attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs[i].answerValue || attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs[i].answerValue === 0) count++;
        }
        if (count === attempt.answers[indexOfOnChangeAnswerInAttempt].textInputs.length)
          attempt.answers[indexOfOnChangeAnswerInAttempt].finishMarking = true;
      }
    }
    this.forceUpdate(function() {
      // Enter Edit mode - focus to mark input
      if (textInput.isEditting) {
        this.refs["text-input-" + textInput._id].focus();
      }
    });
  },
  validateAnswerBeforeSaving: function() {
    var result = {
      isMarkValid: true,
      isFinishValid: true,
      invalidAnswerIndex: -1,
      invalidInputIndex: -1
    }
    var attempt = this.state.attempt;
    for (var i = 0; i < this.state.preBuildAnswers.length; i++) {
      var indexOfAnswerInAttempt = attempt.answers.indexOf(this.state.preBuildAnswers[i]);

      if (!attempt.answers[indexOfAnswerInAttempt].finishMarking) {
        attempt.answers[indexOfAnswerInAttempt].finishMarking = false;
        result.isFinishValid = false;
        result.invalidAnswerIndex = i;
        // return result;
      } else {
        for (var j = 0; j < attempt.answers[indexOfAnswerInAttempt].kquestionInfo.textInputAnswers.length; j++) {
          var textInput = attempt.answers[indexOfAnswerInAttempt].kquestionInfo.textInputAnswers[j];
          if (textInput.markError) {
            result.isMarkValid = false;
            result.invalidAnswerIndex = i;
            result.invalidInputIndex = j;
            return result;
          }
        }
      }
    }
    return result;
  },
  saveAttemptAnswers: function() {
    var attempt = this.state.attempt,
        _this = this,
        answerCount = this.state.preBuildAnswers.length,
        answers = this.state.preBuildAnswers;
    var validation = this.validateAnswerBeforeSaving();
    if (!validation.isFinishValid) {
      notification.open({
        message: 'Error',
        description: 'Please finish marking all questions'
      });
      return this.forceUpdate();
    }
    if (!validation.isMarkValid) {
      notification.open({
        message: "Error",
        description: "Please enter valid mark for answer " + (validation.invalidInputIndex+1) + ", question " + (validation.invalidAnswerIndex+1)
      })
      return this.setState({
        currentAnswerIndex: validation.invalidAnswerIndex
      }, function() {
        var invalidForm = $("#mark-form-" + validation.invalidAnswerIndex + "-" + validation.invalidInputIndex);
        $("body, html").animate({
          scrollTop: invalidForm.offset().top
        },200)
      })
    }
    $("body, html").addClass("heavy-load");
    AttemptRes.updateAttempt({status: 'scored'}, (err, res) => {
      for (var i = 0; i < answers.length; i++) {
        answers[i].status = 'scored';
        this.updateAnswers(answers[i], (err2, res2) => {
          answerCount--;
          if (answerCount <= 0) {
            $("body, html").removeClass("heavy-load");
            this.notificationDialog = createNotificationDialog({
              title: 'Success',
              content: 'Finished marking this submission.'
            }, function() {
              if (attempt.type === 'PRACTICE') {
                browserHistory.push('/submissions/practice');
              } else {
                browserHistory.push('/submissions/exam');
              }        
            })
            this.setState({openNotificationDialog: true});
          }
        })
      }
    })
  },
  updateAnswers: function(answer, callback){
    callback = callback || function(){};

    if (answer.kquestionInfo.type === 22) {
      answer.score = 0;
      for (var i in answer.textInputs) {
        answer.score += parseFloat(answer.textInputs[i].answerValue) || 0;
        if (answer.textInputs[i].isRight !== undefined) {
          answer.kquestionInfo.textInputAnswers[i].type = "AUTO_MARKING";
        } else {
          answer.kquestionInfo.textInputAnswers[i].type = "MANUAL_MARKING";
        }
      } 
    } else {
      for (var i in answer.textInputAnswers) {
        answer.textInputAnswers[i].type = "AUTO_MARKING";
      }
    }

    if (answer.score < answer.kquestionInfo.score) {
      answer.allRight = false;
    } 
    
    AttemptRes.updateAttemptAnswer(this.state.attempt, answer, function(err, res) {
      return callback(err, res);
    })
  },
  navigateAnswer: function(dir) {
    var isValid = true;
    if (dir === 1) {
      var currentIndex = this.state.currentAnswerIndex,
          attempt = this.state.attempt,
          answers = this.state.preBuildAnswers;
      var indexOfAnswerInAttempt = attempt.answers.indexOf(this.state.preBuildAnswers[currentIndex]);
      if (!attempt.answers[indexOfAnswerInAttempt] || !attempt.answers[indexOfAnswerInAttempt].finishMarking) isValid = false;
    }
    if (!isValid) return notification.open({
      message: 'Error',
      description: 'Please enter valid number for all answers'
    });
    this.setState({
      currentAnswerIndex: this.state.currentAnswerIndex + dir
    }, function() {
      $("body, html").animate({scrollTop: 0}, 200);
    })
  },

  getInitialState: function() {
    return {
      isLoading: false,
      attempt: null,
      conceptsMap: null,
      currentAnswerIndex: 0,
      preBuildAnswers: []
    };
  },

  render: function() {
    var _this = this,
        attempt = this.state.attempt,
        conceptsMap = this.state.conceptsMap,
        answerIndex = this.state.currentAnswerIndex,
        answers = this.state.preBuildAnswers;
    
    var answer = answers.length > 0 ? answers[answerIndex] : {};
    return (
      <div>
        {this.state.openNotificationDialog && this.notificationDialog}
        {
          _this.state.isLoading &&
          <div className="central-innerpage-loader">
            <CircularProgress size={64}/>
          </div>
        }
        {
          !_this.state.isLoading && answers.length <= 0 &&
          <h3> No answers for marking </h3>
        }
        {
          !_this.state.isLoading && answers.length > 0 &&
          <div>
            <div className="content-toolbar">
              <h3>Marking</h3>
              <div className="btn-holder">
                <RaisedButton
                  label="Finish"
                  secondary={true}
                  onClick={_this.saveAttemptAnswers}
                />
              </div>
              <hr/>
            </div>
            {
              attempt &&
              <div className="txt-primary margin-bottom-10" style={{fontSize: "17px"}}>
                <span className="padding-right-25">
                  Student:
                  <span className="txt-secondary padding-left-10">{attempt.creatorName}</span>
                </span>
                {
                  conceptsMap ?
                  <span className="padding-right-25">
                    Subject:
                    <span className="txt-secondary padding-left-10">{Helpers.getSubject(this.state.conceptsMap, attempt.concepts[0]).title}</span>
                  </span>
                  :
                  <span className="padding-right-25">No Subject</span>
                }
                {
                  attempt.type !== 'MOCK_EXAM' && conceptsMap &&
                    <span className="padding-right-25">
                      Concept:
                      <span className="txt-secondary padding-left-10">{this.state.conceptsMap[attempt.concepts[0]].title}</span>
                    </span>
                }
                {
                  attempt.type !== 'MOCK_EXAM' && !conceptsMap &&
                  <span className="padding-right-25">No Concept</span>
                } 
                {
                  attempt.type === 'MOCK_EXAM' && 
                  <span className="padding-right-25">{attempt.title}</span>
                }
                {
                  attempt.type === 'MOCK_EXAM' && 
                  <span className="padding-right-25">Exam paper 2</span>
                }
              </div>
            }
            {
              attempt &&
              <div className="margin-top-10 margin-bottom-10">
                <MarkingProgress
                  answers={answers}
                  currentIndex={answerIndex}/>
              </div>
            }
            {
              attempt && conceptsMap &&
              <div className="content-play">
                  <div className="text-desc">
                    <span className="question-index">{answerIndex+1}</span>
                    <span>{answer.numPoints > 0 ? answer.numPoints : answer.kquestionInfo.score + " points"}</span>
                  </div>
                      
                  <div className="content-title">
                    {
                      answer.kquestionInfo.image && 
                      <img src={answer.kquestionInfo.image} style={{"maxWidth": "100%"}}/>
                    }
                    <span dangerouslySetInnerHTML={{__html: answer.kquestionInfo.description || 'No Description'}}></span>
                  </div>
                  <div className="text-input-wrapper">
                    <div className="parts-list">
                      {
                        answer.kquestionInfo.textInputAnswers.map(function(textInput, index) {
                          return (
                            <div key={index} className="part" style={!textInput.text ? {"backgroundColor": "#ffefd5"} : {}}>
                              <PartDescription
                                content={textInput}
                                contentIndex={index}
                                />
                              <PartAnswer
                              content={answer.textInputs[index]}/>
                              <PartResult
                              answer={answer.textInputs[index]} 
                              info={textInput}/>
                              {
                                answer.kquestionInfo.solution[index] && answer.kquestionInfo.solution[index].subItems &&
                                <Solution solution={answer.kquestionInfo.solution[index].subItems} />
                              }
                              <div className="answer-marking">
                                <h3>Marking</h3>
                                  {
                                    textInput.text &&
                                    <div
                                      className={"form-group mark-form " + (textInput.markError === false ? "is-valid" : (textInput.markError === true ? "is-invalid" : ""))}
                                      id={"mark-form-" + answerIndex + "-" + index}
                                      style={{"pointerEvents": "none", opacity: "0.6"}}>
                                      <label className="control-label margin-right-20">Mark</label>
                                      <span className="sign padding-left-15 padding-right-15"></span>
                                        {
                                          (answer.textInputs[index].isRight) && 
                                            <input
                                              value={textInput.partScore}
                                            />
                                        }
                                        {
                                          (!answer.textInputs[index].isRight) && 
                                            <input
                                              value={"0"}
                                            />
                                        }
                                      <span className="total-mark">{"/  " + (textInput.partScore ? textInput.partScore : textInput.answerValue)}</span>
                                    </div>
                                  }
                                  {
                                    !textInput.text &&
                                    <div className={"form-group mark-form " + (textInput.markError === false ? "is-valid" : (textInput.markError === true ? "is-invalid" : ""))} id={"mark-form-" + answerIndex + "-" + index}>
                                      <label className="control-label margin-right-20">Mark</label>
                                      <span className="sign padding-left-15 padding-right-15" onClick={_this.triggerEditTextInput.bind(_this, textInput)}>
                                      </span>
                                        {
                                          textInput.isEditting ?
                                          <input
                                              ref={"text-input-" + textInput._id}
                                              type="number"
                                              className="form-control"
                                              step="0.1"
                                              min="0"
                                              onBlur={_this.triggerEditTextInput.bind(_this, textInput)}
                                              onChange={_this.onTextInputMarkChange.bind(_this, textInput)}
                                              value={answer.textInputs[index].answerValue || (answer.textInputs[index].answerValue === 0 ? 0 : '')}
                                             
                                              />
                                          :
                                          <span
                                              className="mark-value"
                                              onClick={_this.triggerEditTextInput.bind(_this, textInput)}>
                                              {answer.textInputs[index].answerValue || (answer.textInputs[index].answerValue === 0 ? 0 : '')}
                                              {/*{
                                                (answer.textInputs[index].isRight) && 
                                                  <div>{answer.kquestionInfo.textInputAnswers[index].answerValue}</div>
                                              }
                                              {
                                                (!answer.textInputs[index].isRight) && 
                                                  <div>{0}</div>
                                              }*/}
                                              {/*{textInput.partScore}*/}
                                          </span>
                                        }
                                      <span className="total-mark">{"/  " + (textInput.partScore ? textInput.partScore : textInput.answerValue)}</span>
                                    </div>
                                  }
                                  <div className="comment-container">
                                    {
                                      answer.messages.map(function(message, messageIndex) {
                                        if (!message.metadata || (message.metadata && message.metadata.textInputId !== textInput._id)) return null;
                                        return (
                                            <div className="comment" key={messageIndex}>
                                              <div className="comment-title">
                                                  <div className="main">{message.creatorName}</div>
                                                  <div className="sub">{moment(message.dateModified).format('DD MMM, YYYY - hh:mm')}</div>
                                              </div>
                                              <div className="comment-content">
                                                  { message.type === "ANSWER_MESSAGE" &&
                                                    <p>{message.text}</p>
                                                  }
                                              </div>
                                            </div>
                                        )
                                      })
                                    }
                                  <div className="comment-box">
                                    <textarea type="text" className="form-control" placeholder="Write a comment" ref={"comment-answer-" + textInput._id} rows="4"></textarea>
                                    <div className="text-right">
                                        <RaisedButton
                                          primary={true}
                                          label="Comment"
                                          onClick={_this.submitTextInputMessage.bind(_this, textInput._id)}
                                        />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                  </div>
                </div>
              </div>
            }
            <div className="padding-15 margin-bottom-15">
              {
                attempt && answerIndex > 0 &&
                <RaisedButton
                  label="Back"
                  onClick={_this.navigateAnswer.bind(_this, -1)}
                />
              }
              {
                attempt && answerIndex < answers.length-1 &&
                <div className="float-right">
                  <RaisedButton
                    secondary={true}
                    label="Next"
                    onClick={_this.navigateAnswer.bind(_this, 1)}
                  />
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  },

  componentDidMount: function() {
    var _this = this;
    this.retrieveAttempt(function() {
      _this.validateAttemptPermission(function() {
        _this.prebuildAttemptData();
        _this.retrieveConceptsMap();
      })
    })
  },

});

module.exports = MarkingAttempt;



/** WEBPACK FOOTER **
 ** ./src/components/Marking/MarkingAttempt.js
 **/